import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { collection, onSnapshot, query, where } from "firebase/firestore";
import { useAuth } from "./auth/AuthContext";
import { db } from "./firebase";
import MyBabbleGames from "./MyBabbleGames";
import MyOddventureGames from "./MyOddventureGames";
import MyLeopardyGames from "./MyLeopardyGames";

export default function Profile() {
  const { user, logout } = useAuth();
  const [books, setBooks] = useState([]);
  const [booksLoaded, setBooksLoaded] = useState(false);
  const [bookError, setBookError] = useState(null);

  useEffect(() => {
    if (!user) {
      setBooks([]);
      setBooksLoaded(false);
      return;
    }
    const qy = query(collection(db, "nanoking_books"), where("ownerUid", "==", user.uid));
    const unsub = onSnapshot(
      qy,
      (snap) => {
        setBooks(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
        setBooksLoaded(true);
        setBookError(null);
      },
      (err) => {
        console.error("[Profile] books", err);
        setBookError(err.message || "Failed to load books.");
        setBooksLoaded(true);
      }
    );
    return () => unsub();
  }, [user]);

  if (!user) {
    return <div style={{ padding: 24 }}>Loading…</div>;
  }

  return (
    <div style={{ maxWidth: 920, margin: "24px auto", padding: "0 16px" }}>
      <header style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 12 }}>
        <div>
          <h1 style={{ marginBottom: 4 }}>Profile</h1>
          <div style={{ fontSize: 14, opacity: 0.8 }}>
            Signed in as <b>{user.displayName || user.email}</b>
          </div>
        </div>
        <button onClick={logout}>Sign out</button>
      </header>

      <section style={{ marginTop: 20 }}>
        <h2 style={{ margin: "0 0 8px" }}>User details</h2>
        <div style={{ border: "1px solid #e0e0e0", borderRadius: 12, padding: 12, display: "grid", gap: 6, maxWidth: 460 }}>
          <div><strong>UID:</strong> {user.uid}</div>
          <div><strong>Email:</strong> {user.email || "—"}</div>
          <div><strong>Name:</strong> {user.displayName || "—"}</div>
          <div><strong>Anonymous:</strong> {String(user.isAnonymous)}</div>
          <div><strong>Providers:</strong> {(user.providerData || []).map((p) => p.providerId).join(", ") || "—"}</div>
          <div><strong>Provider emails:</strong> {(user.providerData || []).map((p) => p.email).filter(Boolean).join(", ") || "—"}</div>
          {user.photoURL && (
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <strong>Photo:</strong>
              <img src={user.photoURL} alt="avatar" style={{ width: 48, height: 48, borderRadius: "50%", objectFit: "cover" }} />
            </div>
          )}
        </div>
      </section>

      <section style={{ marginTop: 32 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
          <h2 style={{ margin: 0 }}>My Books</h2>
          <Link to="/nanoking" style={{ fontSize: 14 }}>Open NaNo dashboard →</Link>
        </div>
        {bookError && (
          <div style={{ border: "1px solid #e57373", background: "#ffebee", padding: 12, borderRadius: 8, marginTop: 12 }}>
            {bookError}
          </div>
        )}
        {!booksLoaded ? (
          <p style={{ marginTop: 12 }}>Loading books…</p>
        ) : books.length === 0 ? (
          <p style={{ marginTop: 12 }}>No books yet. Create one in the NaNo dashboard.</p>
        ) : (
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))", gap: 16, marginTop: 16 }}>
            {books.map((book) => (
              <div key={book.id} style={{ border: "1px solid #e0e0e0", borderRadius: 12, padding: 16 }}>
                <h3 style={{ margin: "0 0 6px" }}>{book.title || "Untitled book"}</h3>
                <div style={{ fontSize: 13, opacity: 0.85 }}>
                  Total:&nbsp;
                  <b>{Number(book.currentCount || 0).toLocaleString()}</b>
                  {book.targetTotal ? <> / {Number(book.targetTotal).toLocaleString()}</> : null}
                </div>
                {book.dailyGoal ? (
                  <div style={{ fontSize: 13, marginTop: 4, opacity: 0.8 }}>
                    Daily goal: {Number(book.dailyGoal).toLocaleString()}
                  </div>
                ) : null}
              </div>
            ))}
          </div>
        )}
      </section>

      <MyBabbleGames />
      <MyOddventureGames title="My Chadventure Tables" />
      <MyLeopardyGames />
    </div>
  );
}
